import { render } from "./SyncFieldsSelect.vue?vue&type=template&id=83593752&scoped=true"
import script from "./SyncFieldsSelect.vue?vue&type=script&lang=js"
export * from "./SyncFieldsSelect.vue?vue&type=script&lang=js"

import "./SyncFieldsSelect.vue?vue&type=style&index=0&id=83593752&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83593752"]])

export default __exports__